module.exports = __webpack_public_path__ + "assets/img/vuex_getters.6faddd84.jpg";